"use client";

import { useEffect, useState } from "react";
import { type DateInput, formatDateLabel, timeAgo } from "@/lib/utils/format";

type RelativeTimeProps = {
	date: DateInput;
	locale?: string;
	className?: string;
};

export function RelativeTime({ date, locale, className }: RelativeTimeProps) {
	const fallbackLabel = formatDateLabel(date, locale);
	const [label, setLabel] = useState(fallbackLabel);

	useEffect(() => {
		setLabel(timeAgo(date, locale));

		const intervalId = window.setInterval(() => {
			setLabel(timeAgo(date, locale));
		}, 60_000);

		return () => {
			window.clearInterval(intervalId);
		};
	}, [date, locale]);

	return (
		<time className={className} dateTime={new Date(date).toISOString()}>
			{label}
		</time>
	);
}
